<template>
  <div class="tabbar">
    <van-tabbar
      v-model="active"
      inactive-color="#000"
      :safe-area-inset-bottom="true"
      style="background: #ffffff;z-index:99"
    >
      <!-- <van-tabbar-item icon="home-o">首页</van-tabbar-item> -->
      <van-tabbar-item replace to="/">
        <span>首页</span>
        <template #icon="props">
          <van-icon v-if="props.active" name="wap-home" />
          <van-icon v-else name="wap-home-o" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/packageList">
        <span>套餐</span>
        <template #icon="props">
          <van-icon v-if="props.active" name="shopping-cart" />
          <van-icon v-else name="shopping-cart-o" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="userCenter">
        <span>我的</span>
        <template #icon="props">
          <van-icon v-if="props.active" name="manager" />
          <van-icon v-else name="manager-o" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "footerTabbar",
  data() {
    return {
      active: this.activeIndex
    };
  },
  methods: {},
  props: {
    activeIndex: Number
  }
};
</script>